import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import App from './App.vue'
//import config from './config'
//import Amplify, * as AmplifyModules from 'aws-amplify';
//import { AmplifyPlugin } from 'aws-amplify-vue';
import store from './store'
import router from './router'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(Buefy);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
